import { useState } from 'react'
import { useExameLocalService } from 'hooks/useExameLocalService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'

export const useFormExameLocal = (props) => {
  const {
    exameLocal,
    setExameLocal,
    setProcessandoExameLocal,
    processandoExameLocal,
  } = props

  const [activeStep, setActiveStep] = useState(0)
  const [titleList, setTitleList] = useState(['Locais examinados'])
  const [hideNextButton, setHideNextButton] = useState(false)
  const [formLocaisErro, setFormLocaisErro] = useState(false)

  // Native React state to emulate useFormState interface
  const [discussaoState, setDiscussaoState] = useState({ values: { discussao: '' } })
  const [conclusaoState, setConclusaoState] = useState({ values: { conclusao: '' } })
  const [quesitosState, setQuesitosState] = useState({ values: {} })

  const exameLocalService = useExameLocalService()
  const exameRealizadoService = useExameRealizadoService()

  const formDiscussao = {
    formState: discussaoState,
    setFormState: setDiscussaoState,
  }

  const formConclusao = {
    formState: conclusaoState,
    setFormState: setConclusaoState,
  }

  const formQuesitos = {
    formState: quesitosState,
    setFormState: setQuesitosState,
  }

  const handleBack = () => {
    setActiveStep(activeStep - 1)
  }

  const handleNext = async () => {
    if (activeStep === 0) {
      setActiveStep(activeStep + 1)
    }

    if (activeStep === 1) {
      await exameLocalService.editarExameLocal(
        exameLocal.id,
        discussaoState.values,
        setExameLocal,
        setProcessandoExameLocal
      )
      setActiveStep(activeStep + 1)
    }

    if (activeStep === 2) {
      await exameLocalService.editarExameLocal(
        exameLocal.id,
        conclusaoState.values,
        setExameLocal,
        setProcessandoExameLocal
      )
      setActiveStep(activeStep + 1)
    }

    if (activeStep === 3) {
      await exameRealizadoService.responderQuesitosEGerarDocumento(
        exameLocal.id,
        quesitosState.values,
        setProcessandoExameLocal
      )
    }
  }

  const isFormError = () => {
    let disabled = false
    if (activeStep === 0) {
      disabled = formLocaisErro
    }
    return disabled
  }

  return {
    activeStep,
    setActiveStep,
    titleList,
    setTitleList,
    hideNextButton,
    setHideNextButton,
    formLocaisErro,
    setFormLocaisErro,
    formDiscussao,
    formConclusao,
    formQuesitos,
    handleBack,
    handleNext,
    formError: isFormError(),
    processandoExameLocal,
  }
}
